import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { collection, query, where, getDocs } from "firebase/firestore";
import { auth, db } from "../firebase";
import LoadingAnimation from "./LoadingAnimation";

const ProtectedRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const adminsRef = collection(db, "admins");
        const q = query(adminsRef, where("username", "==", user.email));
        const querySnapshot = await getDocs(q);
        
        setIsAdmin(!querySnapshot.empty);
      } else {
        setIsAdmin(false);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

if (loading) {
  return (
    <div className="items-center justify-center">
      <LoadingAnimation />
    </div>
  );
}
  return isAdmin ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;